import React from 'react';
import { Route, IndexRoute } from 'react-router';
import ActionsMenu from './actionsMenu';

export default (
  <Route path="minhas-atividades">
    <IndexRoute component={props => <ActionsMenu {...props} />} />
  </Route>
);
